
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard-login",
      function () {
        return require("private-next-pages/dashboard-login.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard-login"])
      });
    }
  